import { GroupTypeEnum } from '@/types/schema';

export enum GroupMenuActions {
  Edit = 'EDIT',
  Delete = 'DELETE',
  Duplicate = 'DUPLICATE',
  View = 'VIEW',
}

export enum ActionDialog {
  Delete = 'DELETE',
  Share = 'SHARE',
  Duplicate = 'DUPLICATE',
}

export enum DialogActions {
  Delete = 'DELETE',
  Close = 'CLOSE',
}

export interface GroupManagerProps {
  type: GroupTypeEnum;
}

export enum GroupsActions {
  BulkImport = 'BULK_IMPORT',
}

export type GroupImageClassOverries = {
  userCollection: {
    root: string;
    firstPicture: string;
    firstPictureSize: number;
    secondPicture: string;
    secondPictureSize: number;
  };
  contentCollection: {
    root: string;
    firstPicture: string;
    firstPictureSize: number;
    secondPicture: string;
    secondPictureSize: number;
  };
};
